import React, { useState } from 'react'
import { Modal, FormControl } from 'react-bootstrap';
import CustomTemplate from './CustomTemplate'
import AutomatedTemplate from './AutomatedTemplate'
import UserInvitationTemplate from './UserInvitationTemplate'

function filterTemplates(templates, search, additionalKeywords = []) {
  const searchFields = ['subject', 'description', 'recipient', 'sender']
  return templates.filter(template => {
    const searchText = searchFields
      .map(field => template.attributes[field])
      .map(value => value.toLowerCase())
      .concat(additionalKeywords.map(keyword => keyword.toLowerCase()))
      .join(' ')

    return searchText.includes(search.toLowerCase())
  })
}

const QuickSendModal = ({ show, onClose, customTemplates, automatedTemplates, invitationTemplates, urlMapper }) => {
  const [search, setSearch] = useState('')

  const filteredCustomTemplates = filterTemplates(customTemplates, search)
  const filteredAutomatedTemplates = filterTemplates(automatedTemplates, search)
  const filteredInvitationTemplates = filterTemplates(invitationTemplates.templates, search, ["resend", "system"])

  return (
    <Modal show={show} size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Quick Send</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <FormControl
            name="search"
            placeholder="Filter templates..."
            autoFocus
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        
        { filteredCustomTemplates.length > 0 && (
          <div>
            <h5>Custom Templates</h5>
            <div className="list-group mb-3">
              {filteredCustomTemplates.map(customTemplate => (
                <CustomTemplate
                  key={customTemplate.id}
                  customTemplate={customTemplate}
                  urlMapper={urlMapper}
                />
              ))}
            </div>
          </div>
        )}
        { filteredAutomatedTemplates.length > 0 && (
          <div>
            <h5>Automated Messages</h5>
            <div className="list-group mb-3">
              {filteredAutomatedTemplates.map(automatedTemplate => (
                <AutomatedTemplate
                  key={automatedTemplate.id}
                  automatedTemplate={automatedTemplate}
                  urlMapper={urlMapper}
                />
              ))}
            </div>
          </div>
        )}
        { (filteredInvitationTemplates.length > 0 && invitationTemplates.users.length > 0) && (
          <div>
            <h5>System Messages</h5>
            <div className="list-group mb-3">
              {filteredInvitationTemplates.map(template => {
                return invitationTemplates.users.map(user => (
                  <UserInvitationTemplate
                    key={`${template.id}-${user.id}`}
                    template={template}
                    user={user}
                    urlMapper={urlMapper}
                  />
                ))
              })}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose}>Close</button>
      </Modal.Footer>
    </Modal>
  )
}

export default QuickSendModal
